import { useState } from 'react';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { Button } from '@/components/ui/button';
import { Plus, Loader2 } from 'lucide-react';
import { useContractDocuments } from '@/hooks/useContractDocuments';
import { ContractStatusCards } from '@/components/contracts/ContractStatusCards';
import { ContractsList } from '@/components/contracts/ContractsList';
import { ContractUploadDialog } from '@/components/contracts/ContractUploadDialog';

export default function Contracts() {
  const { contracts, isLoading, stats } = useContractDocuments();
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);

  return (
    <DashboardLayout>
      <div className="p-6 space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold tracking-tight">Contracts</h1>
            <p className="text-muted-foreground">
              Manage contracts for contractors and clients
            </p>
          </div>
          <Button onClick={() => setUploadDialogOpen(true)}>
            <Plus className="h-4 w-4 mr-2" />
            Upload Contract
          </Button>
        </div>

        {isLoading ? (
          <div className="flex items-center justify-center py-12">
            <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
          </div>
        ) : (
          <>
            {/* Status Cards */}
            <ContractStatusCards stats={stats} />

            {/* Contracts List */}
            <ContractsList contracts={contracts} />
          </>
        )}

        {/* Upload Dialog */}
        <ContractUploadDialog
          open={uploadDialogOpen}
          onOpenChange={setUploadDialogOpen}
        />
      </div>
    </DashboardLayout>
  );
}
